import { 
	createSlice,
	createAsyncThunk
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'

export const getChat = createAsyncThunk(
	'getChat',
	async (_,{getState})=> {
		const postData = {action:'getChat'}
		//since trainers/clients have different actions
		//that need to be called on the back end use get
		//state to check account type and set the correct
		//post data
		const state = getState()
		const accountType = state.users.current_user.account_type
		//clients only need the action set trainers need recipients 
		//to be sent along with the action
		if(accountType !== 'client'){
			//pull recipient from chat state
			const recipient = state.chat.recipient
			postData.client_id  = recipient
		}
		//make api call and return the result
		return envAwarePost(
			'api/messaging/api/',
			postData
		)
	}
)

export const sendImage = createAsyncThunk(
	'sendImage',
	async ({upload_id,recipient_id}) => envAwarePost(
		'api/messaging/api/',
		{
			action:'sendChatImage',
			upload_id,recipient_id
		}
	)
)

export const sendMessage = createAsyncThunk(
	'sendMessage',
	async (message,{getState}) => {
		const postData = {message}
		//since trainers/clients have different actions
		//that need to be called on the back end use get
		//state to check account type and set the correct
		//post data
		const state = getState()
		const accountType = state.users.current_user.account_type
		//clients only need the action set trainers need recipients 
		//to be sent along with the action
		if(accountType === 'client'){
			postData.action  = 'sendToRecipients'
		}else{
			//pull recipient from chat state
			const recipient = state.chat.recipient
			postData.action = 'sendToSpecified'
			//send to specified needs an array of recipient user_id_numbers
			postData.recipients = [recipient]
		}
		//make api call and return the result
		return envAwarePost(
			'api/messaging/api.php',
			postData
		)
	}
)

const chatSlice = createSlice({
	name: 'chat',
	initialState:{
		status:'idle',
		show:false,
		messages:[],
	},
	reducers: {
		updateShow:(state,action)=>{
			state.show = action.payload
		},
		updateRecipient:(state,action)=>{
			state.recipient = action.payload
		},
		pushNoteReceived:(state,action)=>{
			console.log(action.payload)
			const {body:message,chat_message_type:type,upload_url:url,sender} = action.payload
			state.messages.push({
				dateTime: new Date().toLocaleString(),
				align:'left',
				message,
				sender,
				type,
				url
			})
		}
	},
	extraReducers:{
		[sendMessage.pending] : (state,action)=>{
			const message = action.meta.arg
			state.messages.push({
				sender:'self',
				align:'right',
				type:'text',
				dateTime: new Date().toLocaleString(),
				message
			})
		},
		[sendImage.pending] : (state,action)=>{
			const {upload_id,recipient_id,url} = action.meta.arg
			state.messages.push({
				align:'right',
				type:'upload',
				dateTime: new Date().toLocaleString(),
				url
			})
		},

		[getChat.pending] : (state) => {
			state.status = 'pending'
		},

		[getChat.fulfilled] : (state,action)=>{
			state.status = 'idle'
			const {success,data} = action.payload
			if(success == 1) state.messages = data.reverse()
		}
	}
})

export const {pushNoteReceived,updateShow,updateRecipient} = chatSlice.actions


export default chatSlice.reducer